/* MT article sections (article template) */
  function slugifyHeading(text) {
    return (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^\w\u4e00-\u9fff]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getHeadingLabel(heading) {
    return (heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function ensureHeadingId(heading, index, sectionId, usedIds) {
    if (heading.id) {
      usedIds.add(heading.id);
      return heading.id;
    }

    var base = slugifyHeading(getHeadingLabel(heading)) || sectionId + '-heading-' + index;
    var id = base;
    var suffix = 1;

    while (!id || usedIds.has(id) || document.getElementById(id)) {
      id = base + '-' + suffix;
      suffix += 1;
    }

    heading.id = id;
    usedIds.add(id);
    return id;
  }

  if (!customElements.get('mt-show5')) {
    customElements.define('mt-show5', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.initShare();
        this.initToc();
      }

      disconnectedCallback() {
        if (this._tocObserver) this._tocObserver.disconnect();
      }

      initShare() {
        this.querySelectorAll('[data-share-url]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var url = btn.getAttribute('data-share-url');
            if (!url) return;
            if (navigator.share) {
              navigator.share({ url: url, title: document.title }).catch(function () {});
            } else if (navigator.clipboard) {
              navigator.clipboard.writeText(url).catch(function () {});
            }
          });
        });
      }

      initToc() {
        var content = this.querySelector('[data-mt-show5-content]');
        var list = this.querySelector('[data-mt-show5-toc-list]');
        var aside = this.querySelector('[data-mt-show5-toc-aside]');
        if (!content || !list || !aside) return;

        var headings = Array.from(content.querySelectorAll('h2'));

        if (!headings.length) {
          aside.hidden = true;
          this.classList.remove('mt-show5--with-toc');
          return;
        }

        aside.hidden = false;
        this.classList.add('mt-show5--with-toc');

        var sectionId = this.dataset.sectionId || 'show5';
        var usedIds = new Set();
        var pairs = [];

        list.innerHTML = '';

        headings.forEach((heading, index) => {
          var label = getHeadingLabel(heading);
          if (!label) return;

          var anchorId = ensureHeadingId(heading, index, sectionId, usedIds);
          var item = document.createElement('li');
          item.className = 'mt-show5__toc-item';

          var link = document.createElement('a');
          link.className = 'mt-show5__toc-link';
          link.href = '#' + anchorId;
          link.textContent = label;

          item.appendChild(link);
          list.appendChild(item);
          pairs.push({ link: link, heading: heading });
        });

        if (!pairs.length) {
          aside.hidden = true;
          this.classList.remove('mt-show5--with-toc');
          return;
        }

        this.bindTocPairs(pairs);

        if (window.location.hash) {
          var target = content.querySelector(window.location.hash);
          if (target) {
            setTimeout(function () {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
      }

      bindTocPairs(pairs) {
        pairs.forEach((pair) => {
          pair.link.addEventListener('click', (event) => {
            event.preventDefault();
            pair.heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            pairs.forEach((p) => {
              p.link.classList.remove('is-active');
            });
            pair.link.classList.add('is-active');
            if (history.replaceState) {
              history.replaceState(null, '', '#' + pair.heading.id);
            }
          });
        });

        if ('IntersectionObserver' in window) {
          this._tocObserver = new IntersectionObserver(
            (entries) => {
              var visible = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

              if (!visible.length) return;

              var activeId = visible[0].target.id;
              pairs.forEach((pair) => {
                pair.link.classList.toggle('is-active', pair.heading.id === activeId);
              });
            },
            {
              root: null,
              rootMargin: '-20% 0px -60% 0px',
              threshold: [0, 0.25, 0.5, 1]
            }
          );

          pairs.forEach((pair) => {
            this._tocObserver.observe(pair.heading);
          });
        } else if (pairs[0]) {
          pairs[0].link.classList.add('is-active');
        }
      }
    });
  }
